<template>
    <div class="arch-section" v-if="archArr != null" id="menu-link-arch">
        <div class="container">
            <sectionTitle :options="[{ title : archArr.arch_title}]"></sectionTitle>
            <sectionBaner :options="[{ bg: archArr.arch_quote_img, title : archArr.arch_quote_title, desc: archArr.arch_quote_desc}]"></sectionBaner>
            <sectionDescColumn :options="[{ desc_left : archArr.arch_desc_left, desc_right: archArr.arch_desc_right}]" class="section-desc-column-arch"></sectionDescColumn>
        </div>
        <div class="arch-items-container">
            <div class="arch-item" v-for="(item, index) in archArr.about_cards" :key="index">
                <div class="container">
                    <div class="column-container">
                        <div class="col-left">
                            <div class="col-item-desc">
                                <h2 v-html="item.title"></h2>
                                <p v-html="item.desc"></p>
                            </div>
                        </div>
                        <div class="col-right">
                            <div class="col-item-img" :style="'background-image:url(' + item.img + ')'"></div>
                        </div>
                    </div>
                    <sectionImagesGrid :options="[{ cards: item.materials, init_desc : true}]" class="section-images-grid-second-arch"></sectionImagesGrid>
                    <sectionImagesMobileSecond :options="[{ images: item.images_mobile}]" v-if="isMobileGlobal" class="section-images-mobile-second-arch"></sectionImagesMobileSecond>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import sectionTitle from '@/components/partials/section-title.vue'
    import sectionBaner from '@/components/partials/section-baner.vue'
    import sectionDescColumn from '@/components/partials/section-desc-column.vue'
    import sectionImagesGrid from '@/components/partials/section-images-grid-second.vue'
    import sectionImagesMobileSecond from '@/components/partials/section-images-mobile-second.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'arch-section',
        data () {
            return {
            }
        },
        computed: mapGetters({
            archArr: 'loadArchArr',
            isMobileGlobal: 'loadisMobileGlobal',
        }),
        components: {
            sectionTitle,
            sectionBaner,
            sectionDescColumn,
            sectionImagesGrid,
            sectionImagesMobileSecond,
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/arch/arch-section.scss';
    @import '@/styles/components/arch/arch-section-respond.scss';
</style>